<template>
  <div id="vacances">
    <h2>Gestion des vacances</h2>
    <a href="javascript:" class="mr-3" @click="generatePDF()">
      <img class="imgicon" src="img/pdf.png" /> Télécharger le rapport global en PDF
    </a>
    <div class="mt-3 form-inline filtre">
      <label for="site">Pour le site</label>
      <select id="site" name="site" class="form-control custom-select" v-model="filters.site">
        <option v-for="site in sites" v-bind:key="site.id" v-bind:value="site.id">{{site.nom}}</option>
      </select>
    </div>
    <hr />
    <table width="100%">
      <tr>
        <td width="40%" style="text-align: right">
          <button @click="changeYear(false)" class="btn">
            <font-awesome-icon :icon="'arrow-left'" />
          </button>
        </td>
        <td width="20%" style="text-align: center">
          <h4>{{year}}</h4>
        </td>
        <td width="40%" style="text-align: left">
          <button @click="changeYear(true)" class="btn">
            <font-awesome-icon :icon="'arrow-right'" />
          </button>
        </td>
      </tr>
    </table>
    <div class="form-group">
      <label for="employe">Employé :</label>
      <select @change="loadData" v-model="employe" id="employe" class="custom-select">
        <option :value="undefined">Sélectionner un employé</option>
        <option
          v-for="employe of employes"
          :key="employe.id"
          :value="employe.id"
        >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
      </select>
    </div>
    <div v-if="employe">
      <font-awesome-icon :icon="'plus'" />&nbsp;Ajouter des vacances&nbsp;:&nbsp;
      <date-range-picker
        :locale-data="locale"
        @update="addVacances"
        :ranges="false"
        :date-range="dateRange"
      ></date-range-picker>
    </div>
    <div v-if="vacances.length > 0" class="mt-3 table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col" width="20%">Du</th>
            <th scope="col" width="60%" style="text-align: left;">Au</th>
            <th scope="col" width="20%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vacance of vacances" :key="vacance.id">
            <td>{{utils.toPrettyDate(vacance.debut)}}</td>
            <td>{{utils.toPrettyDate(vacance.fin)}}</td>
            <td>
              <button class="btn btn-danger btn-sm" @click="deleteVacances(vacance.id)">
                <font-awesome-icon :icon="'trash'" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-else>Pas de vacances à signaler...</p>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api";
import utils from "@/utils";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      utils,
      year: moment().year(),
      employes: [],
      vacances: [],
      employe: undefined,
      range: undefined,
      dateRange: {},
      locale: {
        separator: " - ",
        applyLabel: "Ajouter",
        cancelLabel: "Annuler",
        weekLabel: "S",
        customRangeLabel: "Plage personnalisée",
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: moment.localeData().firstDayOfWeek()
      },
      filters: { site: 1 },
      sites: []
    };
  },
  async created() {
    this.sites = (await api.getSites()).data.sites;
    this.employes = (await api.getEmployes()).data.employes;
  },
  methods: {
    changeYear(next) {
      this.year += next ? 1 : -1;
      this.loadData();
    },
    async loadData() {
      this.$store.commit("setLoading", true);
      if (this.employe) {
        this.vacances = (
          await api.getVacancesByEmploye(this.year, this.employe)
        ).data.vacances;
      } else {
        this.adding = false;
        this.vacances = [];
      }
      this.$store.commit("setLoading", false);
    },
    async addVacances(range) {
      let response = await api.addVacances(
        range.startDate,
        range.endDate,
        this.employe
      );
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      if (response.code === 200) {
        this.loadData();
      }
    },
    async deleteVacances(id) {
      let response = await api.deleteVacances(id);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      if (response.code === 200) {
        this.loadData();
      }
    },
    generatePDF() {
      api.pdf(`vacances`, { year: this.year, siteid: this.filters.site }, `vacances`);
    }
  },
  components: { DateRangePicker }
};
</script>